export enum I18NLanguage {
  vi = 'vi-VN',
  en = 'en-EN'
}
